(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/result/assets/javascripts/result.js') >= 0) return;  svs.modules.push('/components/utils/result/assets/javascripts/result.js'); 
var svs = svs || {};

(function(svs, _) {
  'use strict';

  svs.utils = svs.utils || {};
  svs.utils.result = svs.utils.result || {};
  svs.utils.result.CURRENT_TENNIS_GAME = 19;
  svs.utils.result.CURRENT_RESULT = 9;
  svs.utils.result.EXTRATIME1_RESULT = 10;
  svs.utils.result.EXTRATIME2_RESULT = 11;
  svs.utils.result.TENNIS_SETS_RESULT = 12;
  svs.utils.result.CURRENT_RESULT_PRIORITED = 18;
  svs.utils.result.FULLTIME_RESULT = 2;
  svs.utils.result.EXTRATIME_RESULT = 3;
  svs.utils.result.PENALTIES_RESULT = 4;

  var getResultByType = function(results, type) {
    results = results || [];
    var resultType; var returnResult;

    if (results.find) {
      resultType = results.find(function(result) {
        return result.type === type;
      });
      if (resultType) {
        returnResult = resultType;
      }
    } else {
      returnResult = _.findWhere(results, { type: type });
    }
    return returnResult;
  };

  svs.utils.result.getResult = function(match, returnMatchObject) {
    var result;
    if (match && match.result) {
      var finalResult;
      if (match.result.find) {
        finalResult = match.result.find(function(result) {
          return result.isFinalResult;
        });
      } else {
        finalResult = _.findWhere(match.result, { isFinalResult: true });
      }
      if (finalResult) {
        result = finalResult;
      }

      if (!result) {
        result = getResultByType(
          match.result,
          svs.utils.result.CURRENT_RESULT_PRIORITED
        );
        if (!result) {
          result = getResultByType(
            match.result,
            svs.utils.result.CURRENT_RESULT
          );
          if (!result) {
            result = getResultByType(
              match.result,
              svs.utils.result.PENALTIES_RESULT
            );
            if (!result) {
              result = getResultByType(
                match.result,
                svs.utils.result.EXTRATIME2_RESULT
              );
              if (!result) {
                result = getResultByType(
                  match.result,
                  svs.utils.result.EXTRATIME1_RESULT
                );
                if (!result) {
                  result = getResultByType(
                    match.result,
                    svs.utils.result.EXTRATIME_RESULT
                  );
                  if (!result) {
                    result = getResultByType(
                      match.result,
                      svs.utils.result.FULLTIME_RESULT
                    );
                  }
                }
              }
            }
          }
        }
      }
    }
    if (returnMatchObject) {
      match.result = result;
      return match;
    }

    if (result) {
      result.home = result.home || {};
      result.away = result.away || {};
    }

    return result;
  };

  svs.utils.result.getLatestAndTrend = function(
    result,
    homeOrAway,
    currentHomeTeamId,
    currentAwayTeamId
  ) {
    var latestAndTrend = {};
    var trend = [];
    var latest = [];
    var numGoalsPerMatchFor = 0;

    result.result.forEach(function(result) {
      if (result.match) {
        var finalResult = svs.utils.result.getResult(result.match, true);
        if (homeOrAway === 0) {
          latestAndTrend = addLatestAndTrend(finalResult, currentHomeTeamId);
        } else if (homeOrAway === 1) {
          latestAndTrend = addLatestAndTrend(finalResult, currentAwayTeamId);
        }
        numGoalsPerMatchFor += latestAndTrend.numGoalsPerMatchFor;
        latest.push(latestAndTrend.latest);
        trend.push(latestAndTrend.trend);
      }
    });
    return {
      latest: latest,
      trend: trend,
      numGoalsPerMatchFor: numGoalsPerMatchFor
    };
  };

  var addLatestAndTrend = function(finalResult, currentTeamId) {
    var latest;
    var numGoalsPerMatchFor = 0;
    var trend;

    finalResult = finalResult || {};

    if (
      finalResult.result &&
      (finalResult.result.home && finalResult.result.away)
    ) {
      finalResult.result.home = parseInt(finalResult.result.home, 10);
      finalResult.result.away = parseInt(finalResult.result.away, 10);

      if (finalResult.homeTeam.id === currentTeamId) {
        if (finalResult.result.home > finalResult.result.away) {
          latest = 'V';
          trend = 3;
        } else if (finalResult.result.home < finalResult.result.away) {
          latest = 'F';
          trend = 0;
        } else {
          latest = 'O';
          trend = 1;
        }
        numGoalsPerMatchFor += finalResult.result.home;
      } else if (finalResult.awayTeam.id === currentTeamId) {
        if (finalResult.result.home > finalResult.result.away) {
          latest = 'F';
          trend = 0;
        } else if (finalResult.result.home < finalResult.result.away) {
          latest = 'V';
          trend = 3;
        } else {
          latest = 'O';
          trend = 1;
        }
        numGoalsPerMatchFor += finalResult.result.away;
      }
    }
    return {
      latest: latest,
      trend: trend,
      numGoalsPerMatchFor: numGoalsPerMatchFor
    };
  };

  svs.utils.result.getCurrentTrend = function(latest) {
    latest = latest || [];
    if (latest.length > 0) {
      var totalSum = latest.reduce(function(accumulator, currentValue) {
        return accumulator + currentValue;
      }, 0);
      return calcTrend(totalSum, latest.length);
    }
    return 0;
  };
  var calcTrend = function(totalSum, numberOfMatches) {
    if (numberOfMatches > 0) {
      var totalMaxSum = numberOfMatches * 3;
      var trendPercent = totalMaxSum === 0 ? 0 : totalSum / totalMaxSum;

      if (trendPercent < 0.2) {
        return -2;
      }

      if (trendPercent >= 0.2 && trendPercent < 0.4) {
        return -1;
      }

      if (trendPercent >= 0.4 && trendPercent < 0.6) {
        return 0;
      }

      if (trendPercent >= 0.6 && trendPercent < 0.8) {
        return 1;
      }

      if (trendPercent >= 0.8) {
        return 2;
      }
    }

    return 0;
  };
})(svs, _);

 })(window);